import asOwaDateInUserTz from './asOwaDateInUserTz';
import { ICalendarFormatDateCallbacks } from 'office-ui-fabric-react/lib/Calendar';
import _formatMonthDayYear from '../formatters/formatMonthDayYear';
import _formatUserDate from '../formatters/formatUserDate';
import _formatUserTime from '../formatters/formatUserTime';
import _formatYear from '../formatters/formatYear';
import _formatYearMonth from '../formatters/formatYearMonth';

const jsDateFormatter = (fn: typeof _formatUserTime) => (date: Date) => fn(asOwaDateInUserTz(date));

// When showing year/month and long dates we will respect the user's settings
export const formatMonthDayYear = jsDateFormatter(_formatMonthDayYear);
export const formatMonthYear = jsDateFormatter(_formatYearMonth);
export const formatYear = jsDateFormatter(_formatYear);

// When showing just a day, we explicitly do not want padded values.
export const formatDay = (date: Date) => date.getDate().toString();

export const formatUserDate = jsDateFormatter(_formatUserDate);
export const formatUserTime = jsDateFormatter(_formatUserTime);

/**
 * Adapter to format dates provided by office-ui-fabric-react's Calendar
 * using OWA's date and time formats.
 */
export const dateTimeFormatter: ICalendarFormatDateCallbacks = {
    formatMonthDayYear,
    formatMonthYear,
    formatYear,
    formatDay,
};
